/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const notificationUnreadCountDataSchema = z.object({
	count: z.number(),
})

export type NotificationUnreadCountDataSchema = z.infer<typeof notificationUnreadCountDataSchema>
